import { useEffect, useRef, useState } from 'react';

// Reusable hook to capture fast keyboard input from HID RFID/card readers
export default function useCardScanner({ enabled = true, onComplete, debounceMs = 100 }) {
  const [inputValue, setInputValue] = useState('');
  const [buffer, setBuffer] = useState('');
  const timeoutRef = useRef(null);

  useEffect(() => {
    if (!enabled) return;

    const ensureFocus = () => {
      const el = document.getElementById('rfid-input');
      if (el) el.focus();
      return el;
    };

    let el = ensureFocus();
    if (!el) setTimeout(ensureFocus, 100);

    const handleFocusLoss = () => ensureFocus();

    const handleGlobalKeyDown = e => {
      const current = document.getElementById('rfid-input');
      if (current && e.target?.id !== 'rfid-input') {
        current.focus();
        const newValue = current.value + e.key;
        current.value = newValue;
        const event = new Event('input', { bubbles: true });
        current.dispatchEvent(event);
      }
    };

    document.addEventListener('click', handleFocusLoss);
    document.addEventListener('keydown', handleGlobalKeyDown);
    return () => {
      document.removeEventListener('click', handleFocusLoss);
      document.removeEventListener('keydown', handleGlobalKeyDown);
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, [enabled]);

  useEffect(() => {
    if (!enabled || !inputValue) return;
    const newBuffer = buffer + inputValue;
    setBuffer(newBuffer);
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      onComplete && onComplete(newBuffer);
      setBuffer('');
    }, debounceMs);
    setInputValue('');
  }, [inputValue]);

  const ScannerInput = enabled ? (
    <input
      id='rfid-input'
      type='text'
      value={inputValue}
      onChange={e => setInputValue(e.target.value)}
      onBlur={e => e.target.focus()}
      autoFocus
      autoComplete='off'
      spellCheck='false'
      style={{
        position: 'absolute',
        left: -9999,
        opacity: 0,
        pointerEvents: 'none',
        width: 1,
        height: 1,
      }}
    />
  ) : null;

  return { ScannerInput };
}
